class LoansSignUpFormLegalConditionsController {

  constructor(EventEmitter, $stateParams, loansStaticService, $log) {
    'ngInject';
    this.EventEmitter = EventEmitter;
    this.log = $log;
    this.loanId = $stateParams.loanId;
    this.loan = loansStaticService.get(this.loanId);
    this.BASE_URL = 'documents/Condiciones_de_contratacion_';
    this.SOCIAL_HOUSING = 'socialHousingLoan';
    this.AGREEMENT_HOUSING = 'agreementHousingLoan';
    this.SOCIAL_AND_AGREEMENT = 'SV_VC_GDPR.pdf';
    this.MONTHLY_AND_CREDIT ='CV_5S_9S_GDPR.pdf';
  }

  emit() {
    this.onAcceptLegalConditions(this.EventEmitter({accept: this.acceptLegalConditions}));
  }

  getFileName() {
    let url = this.BASE_URL;
    url += (this.loanId === this.SOCIAL_HOUSING || this.loanId === this.AGREEMENT_HOUSING) ? this.SOCIAL_AND_AGREEMENT : this.MONTHLY_AND_CREDIT;
    return url;
  }

  openPdf() {
    const fileName = this.getFileName();
    const openedWindow = window.open(fileName, '_blank');

    if (!openedWindow) {
      this.log.warn('Could not open PDF in a new window, redirecting current view');
      window.location.href = fileName;
    }
  }

}
 
export default LoansSignUpFormLegalConditionsController;


// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansSignUp/loansSignUpForm/loansSignUpFormLegalConditions/loansSignUpFormLegalConditions.controller.js